import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { ORGANIZATION_OVERVIEW_PATH } from '@/components/Entities/paths';
import OrganizationOverviewPage from './OrganizationOverviewPage';

/** Everything under the Overview's path: the page, and a redirect for anything else. */
export default function Routes() {
  const location = useLocation();

  return (
    <Switch>
      <Route exact path={ORGANIZATION_OVERVIEW_PATH} component={OrganizationOverviewPage} />
      {/* A mistyped or stale address under the page lands on the Overview, keeping any filters in it. */}
      <Redirect to={{ pathname: ORGANIZATION_OVERVIEW_PATH, search: location.search }} />
    </Switch>
  );
}
